import type { DrawAndPlaceAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";
import { ALL_ZONES } from "../types/zone";

export function validateDrawAndPlace(
  state: HorrorRaceState,
  action: DrawAndPlaceAction,
): ValidationResult {
  if (state.phase !== "ROUND_DRAW_AND_PLACE") {
    return { valid: false, error: "Not in draw and place phase" };
  }

  const currentPlayerIndex = state.turnOrder[state.currentTurnIndex];
  const currentPlayer = state.players[currentPlayerIndex];

  if (action.playerId !== currentPlayer.id) {
    return { valid: false, error: "Not your turn" };
  }

  if (action.placements.length !== 3) {
    return { valid: false, error: "Must place exactly 3 coins" };
  }

  if (state.drawnCoins.length !== 3) {
    return { valid: false, error: "No coins drawn yet" };
  }

  const placedCharacters = action.placements.map((p) => p.character).sort();
  const drawnCharacters = [...state.drawnCoins].sort();
  if (JSON.stringify(placedCharacters) !== JSON.stringify(drawnCharacters)) {
    return {
      valid: false,
      error: "Placements must match drawn coins",
    };
  }

  for (const placement of action.placements) {
    if (!ALL_ZONES.includes(placement.zone)) {
      return {
        valid: false,
        error: `Invalid zone: ${placement.zone}`,
      };
    }
  }

  return { valid: true };
}
